import * as React from 'react'
import PropTypes from 'prop-types'

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={`min-h-[80px] w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 ring-offset-white placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
        className || ''
      }`}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = 'Textarea'
Textarea.propTypes = {
  className: PropTypes.string
}

export { Textarea }
